import React from "react"

export default function Received() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="11" viewBox="0 0 17 11" fill="none">
         <path fillRule="evenodd" clipRule="evenodd" d="M16.277 0.139404L16.9017 0.761698L10.1416 10.2273L7.40128 7.46386L8.56175 5.83786L10.1416 6.77869L16.277 0.139404ZM10.7911 0L11.4158 0.622293L4.65564 10.0879L0 5.41221L1.03955 4.37666L4.65564 6.63929L10.7911 0Z" fill="#777777" />
      </svg>
   )
}
